import VerifyLogin from './VerifyLogin';

export default VerifyLogin;
